import type { IntercomArticle } from '@core/intercom-integration-types';
import type { PickActions } from '@core/ngrx-legacy';
import { createEntityCollectionStore } from '@core/ngrx-legacy';

const idSelector = (article: { id: string }) => article.id;
const { actions, reducer, selectors, namespace } = createEntityCollectionStore<IntercomArticle>()(
  'intercom-articles',
  {
    idSelector,
  },
);

const IntercomArticlesActions = <PickActions<typeof actions, 'fetchPaginatedCollection'>>actions;

export {
  reducer as IntercomArticlesReducer,
  selectors as IntercomArticlesSelectors,
  namespace as IntercomArticlesNamespace,
  IntercomArticlesActions,
};
